import { useState, ReactNode, useCallback } from 'react';
import { ModalContext, ModalMethods } from './modal-context';

export function ModalProvider({ children }: { children: ReactNode }) {
  const [modals, setModals] = useState<Record<string, ModalMethods>>({});

  const setModal = useCallback((modalName: string, methods: ModalMethods) => {
    setModals((prevModals) => ({ ...prevModals, [modalName]: methods }));
    return null;
  }, []);

  const getModal = useCallback(
    (modalName: string) => {
      return modals ? modals[modalName] : undefined;
    },
    [modals]
  ) as (modalName: string) => ModalMethods | undefined;

  const deleteModal = useCallback((modalName: string) => {
    setModals((prevModals) => {
      const newModals = { ...prevModals };
      delete newModals[modalName];
      return newModals;
    });
  }, []);

  return (
    <ModalContext.Provider
      value={{
        setModal,
        getModal,
        deleteModal,
        modals,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}
